import { createRoot } from 'react-dom/client';
import './index.css';

/**
 * Dois apps no mesmo build, cada um no seu pacote (lazy): /portal/* é o portal externo (cliente e account),
 * que não baixa nada do app interno; o resto é o Radar. Em comum só o React, o @radar/shared e os tokens de tema.
 */
const root = createRoot(document.getElementById('root')!);
if (/^\/portal(\/|$)/.test(location.pathname)) void import('./portal/PortalApp').then((m) => m.mount(root));
else void import('./InternalRoot').then((m) => m.mount(root));
